// extracted by mini-css-extract-plugin
export default {"card":"portfolioCard_card__ZR3O3","trigger":"portfolioCard_trigger__aBz-A"};